module.exports = __webpack_public_path__ + "img/Cooperation.222558e5.svg";